import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../pages/Paymentscreen.css";
import Header_packages from "../components/Header_packages";
import InsuranceComponent from "../components/InsuranceComponent";
import getInsuranceData from "../modals/getInsuranceData";
import PackageScreen from "../components/pacakge-screen";
import { useLoading } from "../contexts/LoadingContext";

const InsuranceScreen = () => {
  const { type, id } = useParams();
  const { isLoading, setIsLoading } = useLoading();

  const isMobile = type === "mobile";
  const isHealth = type === "health";
  const isAccidental = type === "accidental";
  const isCrops = type === "crops";
  const isAgri = type === "home";
  const isBike = type === "bike";
  const isCar = type === "car";

  let service = "insurance";
  if (type === "bike" || type === "car") {
    service = "rsa";
  } else if (type === "home") {
    service = type;
  }

  const items = getInsuranceData(type);

  // Loader setup in useEffect
  useEffect(() => {
    setIsLoading(true);

    setTimeout(() => {
      setIsLoading(false);
    }, 1000); 

    return () => setIsLoading(false);
  }, [type, setIsLoading]);

 
  if (isLoading) {
    return;
  }


  return (
    <div>
      {isMobile ? (
        <div>
          <Header_packages title={`<span style="color:#c84f92; font-weight:600">Phone Hai</span> To Sub Kuch Hai`} />
          <PackageScreen items={items} />
        </div>
      ) : isHealth ? (
        <div>
          <Header_packages title={`<span style="color:#c84f92; font-weight:600">Tandarusti</span> Hazar Nemat Hai`} />
          <PackageScreen items={items} />
        </div>
      )  : isAccidental ? (
        <div>
          <Header_packages title={`<span style="color:#c84f92; font-weight:600">Mahfooz</span> Mustaqbil`} />
          <PackageScreen items={items} />
        </div>
      )  : isCrops ? (
        <div>
          <Header_packages title={`<span style="color:#c84f92; font-weight:600">Meri Fasal</span> Meri Jan`} />
          <PackageScreen items={items} />
        </div>
      ) : isAgri ? (
        <div>
          <Header_packages title={`<span style="color:#c84f92; font-weight:600">Home</span> Content`} />
          <PackageScreen items={items} />
        </div>
      ) : isBike ? (
        <div>
          <Header_packages title={`<span style="color:#c84f92; font-weight:600">Bike</span> Insurance`} />
          <PackageScreen items={items} />
        </div>
      ) : isCar ? (
        <div>
          <Header_packages title={`<span style="color:#c84f92; font-weight:600">Car</span> Insurance`} />
          <PackageScreen items={items} />
        </div>
      ) : (
        <div>
          <Header_packages title={`${type.charAt(0).toUpperCase() + type.slice(1)} Expert`} />
          <PackageScreen items={items} />
        </div>
      )}
    </div>
  );
};

export default InsuranceScreen;
